import { render } from "./Socialnetworks.vue?vue&type=template&id=7ef221f8&scoped=true"
import script from "./Socialnetworks.vue?vue&type=script&lang=js"
export * from "./Socialnetworks.vue?vue&type=script&lang=js"

import "./Socialnetworks.vue?vue&type=style&index=0&id=7ef221f8&scoped=true&lang=css"

import exportComponent from "/Users/don/phpStorm/qr-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef221f8"]])

export default __exports__